var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pagination-button",attrs:{"disabled":_vm.disabled}},[_c('i',{staticClass:"icon",class:_vm.icon,style:({ color: _vm.disabled ? _vm.colors.pagination.buttonDisabled : _vm.colors.pagination.button })})])}
var staticRenderFns = []

export { render, staticRenderFns }